import React, { useEffect, useState } from "react";
import { baseUrl } from '../../config.js'
import useToken from '../../useToken';
import Modal from "../Modal/Modal.js";
import defaultPersona from '../../img/nombre.png';
import Perfil from "./Perfil.jsx";

const IconUser = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

const IconPlus = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 5v14M5 12h14" />
    </svg>
);

const Perfiles = () => {
    const { token } = useToken();
    const [datos, setDatos] = useState([]);
    const [modal, setModal] = useState(false);
    const [archivos, setArchivos] = useState([]);
    const [perfil, setPerfil] = useState({});

    useEffect(() => {
        if (token) getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const getData = async () => {
        try {
            const result = await fetch(baseUrl + "Profiles", {
                headers: { Authorization: `Bearer ${token}` },
            }).then((r) => r.json());

            if (result?.success) {
                setDatos(result?.data || []);
                setArchivos(result?.reqDocuments || []);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const abrirNuevo = () => {
        setPerfil({});
        setModal(true);
    };

    const abrirEditar = (item) => {
        setPerfil(item);
        setModal(true);
    };

    return (
        <section className="contactosSat">
            {modal && (
                <Modal
                    className="modalPerfil persona"
                    setModal={setModal}
                    titulo={perfil?.name ? `Editar perfil ${perfil?.name}` : 'Agregar perfil'}
                >
                    <Perfil
                        perfil={perfil}
                        setPerfiles={setDatos}
                        setModal={setModal}
                        archivos={archivos}
                        setArchivos={setArchivos}
                    />
                </Modal>
            )}

            <div className="contactosSatCard">
                <div className="contactosSatHead">
                    <div className="contactosSatTitle">
                        <span className="contactosSatIcon">
                            <IconUser />
                        </span>
                        <div>
                            <h3>Contactos de facturación</h3>
                            <p>
                                Perfiles con RFC para emitir facturas. Puedes agregar varios contactos.
                            </p>
                        </div>
                    </div>
                    <button type="button" className="contactosSatAdd" onClick={abrirNuevo}>
                        <IconPlus />
                        Agregar perfil
                    </button>
                </div>

                {datos.length === 0 ? (
                    <div className="contactosSatEmpty">
                        <span className="contactosSatEmptyIcon"><IconUser /></span>
                        <strong>Aún no tienes contactos</strong>
                        <span>Agrega un perfil con nombre y RFC para usarlo en tus facturas.</span>
                        <button type="button" className="contactosSatAdd" onClick={abrirNuevo}>
                            <IconPlus />
                            Agregar el primero
                        </button>
                    </div>
                ) : (
                    <div className="contactosSatGrid">
                        {datos.map((item, index) => (
                            <button
                                type="button"
                                key={item.idProfile || item.rfc || index}
                                className="contactoSat"
                                onClick={() => abrirEditar(item)}
                            >
                                <span className="contactoSatAvatar">
                                    <img src={item?.url || defaultPersona} alt="" />
                                </span>
                                <span className="contactoSatInfo">
                                    <strong>{item?.name || 'Sin nombre'}</strong>
                                    <em>{item?.rfc || 'Sin RFC'}</em>
                                </span>
                                <span className="contactoSatAction">Editar</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Perfiles;
